export interface AdminUserRequestModel {
  name: string;
  email: string;
  password?: string;
}
